import { render, staticRenderFns } from "./PermissionsUpdate.vue?vue&type=template&id=819c4752&"
import script from "./PermissionsUpdate.vue?vue&type=script&lang=js&"
export * from "./PermissionsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports